import React from 'react'

// Componentes
import Sticky from '../../components/shared/react-sticky/sticky.js'
import StickyContainer from '../../components/shared/react-sticky/container.js'
import HeaderConFiltro from '../../components/shared/HeaderConFiltro.jsx'

// Styles
import * as css from './TablaSemanal.css'

class TablaInventarios extends React.Component {
    render() {
        return (
            <StickyContainer type={React.DOM.table} className={"table table-bordered table-condensed " + css.tableFixed}>
                <colgroup>
                    <col className={css.thCorrelativo} />
                    <col className={css.thLogistica}/>
                    <col className={css.thLogistica}/>
                    <col className={css.thFecha} />
                    <col className={css.thCliente} />
                    <col className={css.thCeco} />
                    <col className={css.thRegion} />
                    <col className={css.thComuna} />
                    <col className={css.thTurno} />
                    <col className={css.thTienda} />
                    <col className={css.thStock} />
                    <col className={css.thDotacionTotal} />
                    <col className={css.thUsuario} />
                    <col className={css.thHora} />
                    <col className={css.thHora} />
                    <col className={css.thUsuario} />
                    <col className={css.thUsuario} />
                    <col className={css.thHora} />
                    <col className={css.thDireccion} />
                    <col className={css.thCheckboxNomina} />
                    <col className={css.thNomina} />
                    <col className={css.thNominaEstado} />
                    <col className={css.thPatentes} />
                    <col className={css.thPda} />
                    <col className={css.thUnidadesReales} />
                    {/* <col className={css.thUnidadesTeoricas} /> */}
                    <col className={css.thArchivoFinal} />
                    {/*<col className={css.thNomimaPago}/>*/}
                </colgroup>
                <thead>
                    {/* TR que se pega al top de la pagina, es una TR, con instancia de 'Sticky' */}
                    <Sticky
                        topOffset={-50}
                        type={React.DOM.tr}
                        stickyStyle={{ top: '50px' }}>

                        <th className={css.thCorrelativo}>#</th>
                        <th className={css.thLogistica}>Log</th>
                        <th className={css.thInv}>INV</th>
                        <th className={css.thFecha}>
                            <HeaderConFiltro
                                nombre='Fecha'
                                filtro={this.props.filtros.filtroFechas || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroFechas')}
                                // se quita el boton de ordenar por dos motivos:
                                // 1) espacio
                                // 2) todas las listas por defecto se ordenan en la vista semanal, solo en la mensual se desordenan
                                ordenarLista={this.props.ordenarInventarios}
                            />
                        </th>
                        <th className={css.thCliente}>
                            <HeaderConFiltro
                                nombre='CL'
                                filtro={this.props.filtros.filtroClientes || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroClientes')}
                                busquedaExacta={true}
                            />
                        </th>
                        <th className={css.thCeco}>
                            <HeaderConFiltro
                                nombre='CE'
                                filtro={this.props.filtros.filtroCeco || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroCeco')}
                                busquedaExacta={true}
                            />
                        </th>
                        <th className={css.thRegion}>
                            <HeaderConFiltro
                                nombre='R'
                                filtro={this.props.filtros.filtroRegiones || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroRegiones')}
                                busquedaExacta={true}
                            />
                        </th>
                        <th className={css.thComuna}>
                            <HeaderConFiltro
                                nombre='Comuna'
                                filtro={this.props.filtros.filtroComunas || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroComunas')}
                            />
                        </th>
                        <th className={css.thTurno}>
                            <HeaderConFiltro
                                nombre='T'
                                filtro={this.props.filtros.filtroTurnos || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroTurnos')}
                            />
                        </th>
                        <th className={css.thTienda}>Tienda</th>
                        <th className={css.thStock}>Stock</th>
                        <th className={css.thDotacionTotal}>Dot.Total</th>
                        <th className={css.thUsuario}>
                            <HeaderConFiltro
                                nombre='Lider'
                                filtro={this.props.filtros.filtroLideres || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroLideres')}
                            />
                        </th>
                        <th className={css.thHora}>
                            <HeaderConFiltro
                                nombre="Hr.Lider"
                                filtro={this.props.filtros.filtroHoraLider || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroHoraLider')}
                            />
                        </th>
                        <th className={css.thHora}>Hr.Equipo</th>
                        <th className={css.thUsuario}>
                            <HeaderConFiltro
                                nombre='Supervisor'
                                filtro={this.props.filtros.filtroSupervisores || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroSupervisores')}
                            />
                        </th>
                        <th className={css.thUsuario}>
                            <HeaderConFiltro
                                nombre='Captador'
                                filtro={this.props.filtros.filtroCaptadores || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroCaptadores')}
                            />
                        </th>
                        <th className={css.thHora}>
                            <HeaderConFiltro
                                nombre='Egreso'
                                filtro={this.props.filtros.filtroEgreso || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroEgreso')}
                            />
                        </th>
                        <th className={css.thDireccion}>Dirección</th>
                        <th className={css.thCheckboxNomina}>
                            <input
                                type="checkbox"
                                onChange={(e) => this.props.handleCheckedNomina(e.target.checked)}
                                //checked = {this.props.initialChecked}
                            />
                        </th>
                        <th className={css.thNomina}>
                            {<HeaderConFiltro
                                nombre='Nómina'
                                filtro={this.props.filtros.filtroNominas || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroNominas')}
                            />
                            }
                        </th>
                        <th className={css.thNominaEstado}>
                            {<HeaderConFiltro
                                nombre="E"
                                filtro={this.props.filtros.filtroNominasEstado || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroNominasEstado')}
                            />
                            }
                        </th>
                        <th className={css.thPatentes}>
                            {<HeaderConFiltro
                                nombre="R"
                                filtro={this.props.filtros.filtroAsistencia || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroAsistencia')}
                            />
                            }
                        </th>
                        <th className={css.thPatentes}>PTT</th>
                        <th className={css.thPda}>PDA</th>
                        <th className={css.thUnidadesReales}>
                            {<HeaderConFiltro
                                nombre="U/Con"
                                filtro={this.props.filtros.filtroUnidades || []}
                                actualizarFiltro={this.props.actualizarFiltro.bind(this, 'filtroUnidades')}
                            />
                            }
                        </th>
                        {/* <th className={css.thUnidadesTeoricas}>U.Teo</th> */}
                        <th className={css.thArchivoFinal}>Acta</th>
                        {/*<th className={css.thNomimaPago}>Nom.Pago</th>*/}
                    </Sticky>
                </thead>
                <tbody>
                    {this.props.children}
                </tbody>
            </StickyContainer>
        )
    }
}
TablaInventarios.propTypes = {
    // Objetos
    filtros: React.PropTypes.objectOf(React.PropTypes.array).isRequired,
    // Metodos
    ordenarInventarios: React.PropTypes.func.isRequired,
    actualizarFiltro: React.PropTypes.func.isRequired
}
export default TablaInventarios


// WEBPACK FOOTER //
// ./frontEnd/inventarios/programacion-semanal/TablaSemanal.jsx